import { useAtomValue } from 'jotai';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { $CurrentExperienceAnswerAsAvailable } from '../../atoms';
import { LegacyArticleUtil } from 'shared/models';
import { useSEOHref } from '~/utils/build-seo-url';

import './style.scss';

export const AiAuthor: FC = () => {
  const { t } = useTranslation();
  const { articleInfoList, submitTimeStamp } = useAtomValue($CurrentExperienceAnswerAsAvailable);
  if (!articleInfoList.length) {
    return null;
  }
  const { author } = articleInfoList[0];
  const authorLink = useSEOHref(LegacyArticleUtil.getAuthorPath(articleInfoList[0]));
  const { avatar, nickName } = author;

  const publishDate = useMemo(() => {
    const date = new Date(submitTimeStamp * 1000);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${year}-${month}-${day}`;
  }, [submitTimeStamp]);

  return (
    <div>
      <div className="experience-posted-by">
        <span>{t('seo_keyword_page_postedBy')}</span>
        <img src={avatar} alt={nickName} loading="lazy" className="author-avatar" />
        <a href={authorLink} className="author-name">
          {nickName}
        </a>
      </div>
      <div className="experience-posted-date">
        <span>{t('seo_kep_timeStamp').replace('%s', publishDate)}</span>
      </div>
    </div>
  );
};
